// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._PLCODYwkGI1GWyoyefZ{width:320px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}html[dir] .c2R6yDFCISs3V6D1mOi8._PLCODYwkGI1GWyoyefZ{background:var(--neutralLighter)}@media only screen and (max-width:1400px){.ypwsbFaWM85HspOO_o5N._PLCODYwkGI1GWyoyefZ{width:calc(100vw - 1080px);min-width:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"underlay": "_PLCODYwkGI1GWyoyefZ",
	"placeholder": "c2R6yDFCISs3V6D1mOi8",
	"shrinkable": "ypwsbFaWM85HspOO_o5N"
};
module.exports = ___CSS_LOADER_EXPORT___;
